import { useMemo } from 'react';

import { useTenantSecrets } from '@/hooks/useSwr';

export function useTenantSecretSet() {
  const tenantSecrets = useTenantSecrets();
  return useMemo(
    () =>
      new Set(tenantSecrets.data?.map((i) => i.key.toLocaleUpperCase()) ?? []),
    [tenantSecrets.data]
  );
}
